<div class="success-container">
  <!-- Loading State -->
  <div class="loading-state" *ngIf="verificationStatus === 'loading'">
    <div class="loader-spinner"></div>
    <h2>Verifying your payment...</h2>
    <p>Please wait while we confirm your registration.</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="verificationStatus === 'error'">
    <div class="error-icon">
      <i class="bi bi-exclamation-triangle"></i>
    </div>
    <h2>Something went wrong</h2>
    <p class="error-message">{{ error }}</p>
    <div class="error-actions">
      <button class="btn-primary" (click)="goToCommunitySessions()">
        Browse Sessions
      </button>
      <a href="mailto:support@nexgencoaches.com" class="btn-outline">
        Contact Support
      </a>
    </div>
  </div>

  <!-- Success State -->
  <div class="success-state" *ngIf="verificationStatus === 'success'">
    <!-- Confetti Animation -->
    <div class="confetti" *ngIf="showConfetti">
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
      <div class="confetti-piece"></div>
    </div>

    <!-- Success Header -->
    <div class="success-header">
      <div class="success-badge">
        <i class="bi bi-check-circle-fill"></i>
      </div>
      <h1>Registration Confirmed! 🎉</h1>
      <p class="subtitle">Thank you for supporting {{ sessionDetails.charity }}</p>
    </div>

    <!-- Session Card -->
    <div class="session-card">
      <div class="session-header">
        <span class="cause-badge">{{ sessionDetails.causeLabel }}</span>
        <span class="price-badge">${{ sessionDetails.amount }}</span>
      </div>

      <h2 class="session-title">{{ sessionDetails.title }}</h2>
      
      <div class="session-quote" *ngIf="sessionDetails.quote">
        <i class="bi bi-quote"></i>
        <p>"{{ sessionDetails.quote }}"</p>
      </div>

      <div class="charity-info">
        <i class="bi bi-heart-fill"></i>
        <span>100% of net proceeds support <strong>{{ sessionDetails.charity }}</strong></span>
      </div>

      <!-- Date & Time -->
      <div class="datetime-section">
        <div class="datetime-item">
          <i class="bi bi-calendar-check"></i>
          <div>
            <span class="label">Date</span>
            <span class="value">{{ sessionDetails.date | date:'fullDate' }}</span>
          </div>
        </div>
        <div class="datetime-item">
          <i class="bi bi-clock"></i>
          <div>
            <span class="label">Time</span>
            <span class="value">{{ sessionDetails.time }}</span>
          </div>
        </div>
      </div>

      <!-- Zoom Link Section -->
      <div class="zoom-section">
        <h3>Your Zoom Link</h3>
        <div class="zoom-link-box">
          <a [href]="sessionDetails.zoomLink" target="_blank" class="zoom-link">
            {{ sessionDetails.zoomLink }}
          </a>
          <button class="copy-btn" (click)="copyZoomLink()" title="Copy link">
            <i class="bi bi-files"></i>
          </button>
        </div>
        <p class="zoom-note">
          <i class="bi bi-info-circle"></i>
          The link will be active 10 minutes before the session starts.
        </p>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button class="btn-primary" (click)="addToCalendar()">
          <i class="bi bi-calendar-plus"></i>
          Add to Calendar
        </button>
        <button class="btn-outline" (click)="goToMySessions()">
          Browse Sessions
        </button>
      </div>
    </div>

    <!-- Email Confirmation Note -->
    <div class="email-note">
      <i class="bi bi-envelope-check"></i>
      <p>
        We've sent a confirmation email to your inbox with all the details.
        <br>
        <small>Can't find it? Check your spam folder.</small>
      </p>
    </div>

    <!-- Charity Impact Message -->
    <div class="impact-message" *ngIf="sessionDetails.charity">
      <h3>Your impact</h3>
      <p>
        Your contribution helps <strong>{{ sessionDetails.charity }}</strong> continue their 
        important work. Thank you for coaching with purpose.
      </p>
    </div>

    <!-- Auto-redirect Countdown -->
    <div class="redirect-note">
      <p>
        Redirecting to <strong>My Sessions</strong> in {{ countdown }} seconds...
      </p>
      <button class="text-link" (click)="goToMySessions()">
        Go now
      </button>
    </div>

    <!-- Share Section -->
    <!-- <div class="share-section">
      <p>Share this cause with your network:</p>
      <div class="share-buttons">
        <a href="https://www.facebook.com/sharer/sharer.php?u={{ websiteUrl }}" 
           target="_blank" class="share-btn facebook">
          <i class="bi bi-facebook"></i>
        </a>
        <a href="https://twitter.com/intent/tweet?text=I%27m%20supporting%20{{ sessionDetails.charity }}%20through%20NEXGEN%20Community%20Sessions!&url={{ websiteUrl }}" 
           target="_blank" class="share-btn twitter">
          <i class="bi bi-twitter-x"></i>
        </a>
        <a href="https://www.linkedin.com/sharing/share-offsite/?url={{ websiteUrl }}" 
           target="_blank" class="share-btn linkedin">
          <i class="bi bi-linkedin"></i>
        </a>
      </div>
    </div> -->
  </div>
</div>

<!-- Registration ID (hidden but useful for debugging) -->
<div class="registration-id" *ngIf="sessionDetails.registrationId">
  <small>Registration ID: {{ sessionDetails.registrationId }}</small>
</div>


<!-- No-Payment Alert Overlay -->
<div class="np-overlay" *ngIf="showNoPaymentAlert">
  <div class="np-backdrop"></div>
  <div class="np-modal">
    <div class="np-icon-wrap">
      <div class="np-icon-ring"></div>
      <svg class="np-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>

    <p class="np-eyebrow">Access Denied</p>
    <h2 class="np-title">No Payment Found</h2>
    <p class="np-body">
      You haven't completed a payment.<br/>
      You'll be redirected to Community Sessions automatically.
    </p>

    <div class="np-timer-bar-wrap">
      <div class="np-timer-label">Redirecting in <span class="np-countdown">{{ redirectCountdown }}s</span></div>
      <div class="np-timer-track">
        <div class="np-timer-fill" [style.width.%]="timerProgress"></div>
      </div>
    </div>

    <button class="np-btn" (click)="redirectNow()">
      Take Me There Now
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"/>
        <polyline points="12 5 19 12 12 19"/>
      </svg>
    </button>
  </div>
</div>